// get employeee list for admin workforce
export const RESET_FORGOT_PASSWORD = "RESET_FORGOT_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_success";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_failure";
